import TabBarForLeaves from "./TabBarForLeaves"

const Leave = () => {
  return (
    <>
      <TabBarForLeaves />
    </>
  )
}

export default Leave
